module.exports = __webpack_public_path__ + "static/media/brasil_new_pastures-tablet.0db9dbbb.jpg";